export default __webpack_public_path__ + "img/equipments-standalone-banner.asset.e07c1ab4.png";